import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        const handleAnchorClick = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            if (target instanceof HTMLAnchorElement && target.hash && target.hash.startsWith("#")) {
                e.preventDefault();
                const section = document.querySelector(target.hash);
                if (section) {
                    window.scrollTo({
                        top: section.getBoundingClientRect().top + window.scrollY - 80,
                        behavior: "smooth",
                    });
                }
            }
        };

        document.addEventListener("click", handleAnchorClick);
        return () => document.removeEventListener("click", handleAnchorClick);
    }, []);

    useEffect(() => {
        if (hash) {
            const section = document.querySelector(hash);
            if (section) {
                window.scrollTo({
                    top: section.getBoundingClientRect().top + window.scrollY - 80,
                    behavior: "smooth",
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);
}
